export default __webpack_public_path__ + "static/media/crop.831d6536.jpg";